/**
 * Enum representing possible vendor participation statuses
 */
export enum VendorParticipationStatus {
  PENDING = 'pending',
  PARTICIPATING = 'participating',
  DECLINED = 'declined'
}

/**
 * Interface representing the vendor's status information
 */
export interface VendorStatus {
  /** The unique identifier of the vendor */
  vendorId: string;
  /** Timestamp of the last update in string format */
  lastUpdatedAt: string;
  /** Current participation status of the vendor */
  status: VendorParticipationStatus;
}
